import React from "react";
import { Tooltip, Button, Dropdown, Menu, Badge, Radio, Popover } from "antd";
import { observer } from "mobx-react";
import { ExportToCSV, ExportToExcel } from "../components/ExportToCSV";
import { OFTableController } from "../OFTableController";
import { toJS } from "mobx";
import { translateKey as t } from "../../../locales/translation";
// import type { MenuProps } from "antd";

import _ from "lodash";
import { Pagination } from "./Pagination";
import { config } from "../../../config/configUi";
import { TableSearch } from "./TableSearch";
import { awesomeIcon } from "../../../utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faArrowDownUpAcrossLine,
  faArrowDownZA,
  faArrowsUpToLine,
  faCalculator,
  faCircleInfo,
  faDownload,
  faEllipsisVertical,
  faFilter,
  faFlask,
  faTextWidth,
  faThumbTack,
} from "@fortawesome/free-solid-svg-icons";

const buttonSize = "small";

const RenderTableMenu = observer(
  ({
    ofTableController,
    menuButtons,
    additionalExports,
    exportName,
    customExportName,
  }: {
    ofTableController: OFTableController;
    menuButtons: any;
    additionalExports: any;
    exportName: any;
    customExportName: any;
  }) => {
    const filterStateChange = () => {
      return ofTableController.filteredColumns.length === 0 && _.isEmpty(ofTableController.hiddenFilterValues);
    };

    const sortingStateChange = () => {
      return ofTableController.sortBy;
    };

    // Pass instance prop to each custom component
    const renderCustomButtons = () => {
      return menuButtons.map((element) => {
        return React.cloneElement(element);
      });
    };

    const renderExportMenu = () => {
      return (
        <Menu>
          {!ofTableController.props?.hideDefaultExport && (
            <Menu.Item key="1" onClick={() => ExportToCSV(ofTableController, exportName, customExportName)}>
              {t("lblExportAsCSV", " Export as CSV")}
            </Menu.Item>
          )}
          {!ofTableController.props?.hideDefaultExport && (
            <Menu.Item key="2" onClick={() => ExportToExcel(ofTableController, exportName, customExportName)}>
              {t("lblExportAsExcel", " Export as Excel")}
            </Menu.Item>
          )}
          {additionalExports && getAdditionalExportOptions(additionalExports)}
        </Menu>
      );
    };

    const getAdditionalExportOptions = (additionalExports) => {
      const elements = [];

      additionalExports.forEach((option: any, i) => {
        elements.push(
          <Menu.Item key={i + option.name} disabled={option.disabled} onClick={option.funcName}>
            {option.name}
          </Menu.Item>
        );
      });

      return elements;
    };

    const renderTableInfo = () => {
      return ofTableController.props?.tableInfo.map((info, i) => <div key={i + "info"}>{toJS(info)}</div>);
    };

    if (ofTableController.props?.compactMode) {
      return null;
    }

    const moreTableOptions = () => {
      return (
        <Menu className="tableOptionDropDown">
          <li style={{ padding: "5px 12px" }}>
            <b>{t("lblOtherSettings", "Other Settings")}</b>
          </li>
          <Menu.Divider style={{ margin: 0 }} />

          <Menu.Item
            data-e2e="hide-filters"
            key="1"
            onClick={() => ofTableController.showHideFilters()}
            className={ofTableController.showFilters ? "active" : ""}
          >
            <FontAwesomeIcon icon={faFilter} style={{ marginRight: 5 }} />
            {ofTableController.showFilters ? t("lblHideFilters", "Hide Filters") : t("lblShowFilters", "Show Filters")}
          </Menu.Item>

          {ofTableController.showTotalsMenu && (
            <Menu.Item
              key="2"
              onClick={() => ofTableController.showHideColTotals()}
              className={ofTableController.showColTotals ? "active" : ""}
            >
              <FontAwesomeIcon icon={faCalculator} style={{ marginRight: 5 }} />

              {ofTableController.showColTotals ? t("lblHideTotals", "Hide Totals") : t("lblShowTotals", "Show Totals")}
            </Menu.Item>
          )}

          {ofTableController.props?.fixedColumns && (
            <Menu.Item
              key="3"
              onClick={() => ofTableController.enableDisableFixedCols()}
              className={ofTableController.fixedColumns ? "active" : ""}
            >
              <FontAwesomeIcon icon={faThumbTack} style={{ marginRight: 5 }} />
              {ofTableController.fixedColumns
                ? t("lblUnpinColumns", "Unpin Columns")
                : t("lblPinColumns", "Pin Columns")}
            </Menu.Item>
          )}

          {ofTableController?.props?.columnOrganiser?.permission === true && (
            <Menu.Item key="4" onClick={() => (ofTableController.showColOrganiser = true)}>
              <FontAwesomeIcon icon={faTextWidth} style={{ marginRight: 5 }} />
              {t("lblColumnOrganiser", "Column Organiser")}
            </Menu.Item>
          )}

          {/* here qwerty */}
          {ofTableController?.fixedRows && (
            <Menu.Item key="5" onClick={() => ofTableController.resetPinnedRows()}>
              <FontAwesomeIcon icon={faThumbTack} style={{ marginRight: 5 }} />
              {t("lblUnpinAllRows", "Unpin All Rows")}
            </Menu.Item>
          )}

          {!config.configOverride && (
            <Menu.Item data-e2e="hide-filters" key="6" onClick={() => ofTableController.debugTable()}>
              <FontAwesomeIcon icon={faFlask} style={{ marginRight: 5 }} />
              {t("lblDebugTable", "Debug Table")}
            </Menu.Item>
          )}

          <Menu.Divider style={{ margin: 0 }} />
          <li style={{ padding: "5px 12px" }}>
            <b>{t("lblViewMode", "View Mode")}</b>
          </li>
          <Menu.Divider style={{ margin: 0 }} />

          <Radio.Group
            data-e2e="view-mode"
            value={ofTableController.viewMode}
            onChange={(e) => ofTableController.viewModeChange(e.target.value)}
          >
            <Radio data-e2e="view-mode-compact" style={{ display: "block", padding: "5px 12px" }} value="compact">
              {t("lblCompact", "Compact")}
            </Radio>
            <Radio data-e2e="view-mode-default" style={{ display: "block", padding: "5px 12px" }} value="default">
              {t("lblDefault", "Default")}
            </Radio>
            <Radio data-e2e="view-mode-detailed" style={{ display: "block", padding: "5px 12px" }} value="detailed">
              {t("lblDetailed", "Detailed")}
            </Radio>
          </Radio.Group>
        </Menu>
      );
    };

    return (
      <div className="tableMenu">
        {ofTableController.viewMode !== "card" && (
          <>
            <Tooltip title={t("lblResetColumnFilters", "Reset Column Filters")} placement="topLeft" mouseLeaveDelay={0}>
              <Button
                data-e2e="reset-all-filters-btn"
                size={buttonSize}
                onClick={() => ofTableController.resetAllFilters()}
                disabled={filterStateChange()}
                style={{ marginRight: "5px" }}
              >
                <FontAwesomeIcon
                  icon={faFilter}
                  // theme={!filterStateChange ? "filled" : "outlined"}
                  style={!filterStateChange() ? { color: "#1890ff" } : {}}
                />
              </Button>
            </Tooltip>

            <Tooltip title={t("lblResetSorting", "Reset Sorting")} placement="topLeft" mouseLeaveDelay={0}>
              <Button
                size={buttonSize}
                onClick={() => ofTableController.resetSorting()}
                disabled={!sortingStateChange()}
                style={{ marginRight: "5px" }}
              >
                <FontAwesomeIcon icon={faArrowDownZA} style={sortingStateChange() ? { color: "#1890ff" } : {}} />
              </Button>
            </Tooltip>

            <Tooltip title={t("lblResetColumnWidths", "Reset Column Widths")} placement="topLeft" mouseLeaveDelay={0}>
              <Button
                size={buttonSize}
                onClick={() => ofTableController.resetColumnWidth()}
                disabled={!ofTableController.customColumnWidth}
                style={{ marginRight: "5px" }}
              >
                <FontAwesomeIcon
                  icon={faArrowDownUpAcrossLine}
                  style={ofTableController.getColumnWidthCookie() ? { color: "#1890ff" } : {}}
                  rotate={90}
                />
              </Button>
            </Tooltip>
          </>
        )}

        <Tooltip title={t("lblScrollBackToTop", "Scroll Back To Top")} placement="topLeft" mouseLeaveDelay={0}>
          <Button
            size={buttonSize}
            onClick={() => ofTableController.scrollToRow(true)}
            style={{ marginRight: "5px" }}
            disabled={!ofTableController.canScrollTop}
          >
            <FontAwesomeIcon icon={faArrowsUpToLine} />
          </Button>
        </Tooltip>

        {ofTableController.viewMode !== "card" && (
          <>
            {ofTableController.props?.showHideMultiSelected && (
              <Tooltip
                title={t("lblShowHideMultiSelectedRows", "Show/Hide Multi-Selected Rows")}
                placement="topLeft"
                mouseLeaveDelay={0}
              >
                <Button
                  size={buttonSize}
                  disabled={ofTableController.multiSelectedRows.totSelected === 0}
                  style={{ marginRight: "5px" }}
                  onClick={() => (ofTableController.showHideMultiSelected = !ofTableController.showHideMultiSelected)}
                  type={ofTableController.showHideMultiSelected ? "primary" : "default"}
                >
                  {awesomeIcon("check-double")}
                </Button>
              </Tooltip>
            )}
          </>
        )}

        {!ofTableController.props?.hideExport && (
          <Dropdown
            overlay={renderExportMenu()}
            trigger={["click"]}
            disabled={ofTableController.tableData.length === 0}
          >
            <Button
              size={buttonSize}
              style={{ marginRight: "5px" }}
              disabled={ofTableController.tableData.length === 0}
            >
              {!ofTableController.mobileRender ? (
                <>
                  {t("lblExports", "Exports")} <FontAwesomeIcon icon={faAngleDown} />
                </>
              ) : (
                <FontAwesomeIcon icon={faDownload} />
              )}
            </Button>
          </Dropdown>
        )}

        {ofTableController.viewMode !== "card" && (
          <>
            {ofTableController.props?.tableInfo && (
              <Popover
                placement="bottomLeft"
                title={t("lblTableInfo", "Table Info")}
                content={renderTableInfo()}
                trigger="click"
                align={{ offset: [-5, 0] }}
              >
                <Button size={buttonSize} style={{ marginRight: "5px" }}>
                  <FontAwesomeIcon icon={faCircleInfo} />
                </Button>
              </Popover>
            )}

            <Dropdown
              // menu={{
              //   items: [
              //     {
              //       key: 'menu',
              //       label: moreTableOptions(),
              //       // disabled: true, // To prevent item click handling
              //     },
              //   ],
              // }}

              overlay={moreTableOptions}
              trigger={["click"]}
            >
              <Tooltip
                title={
                  ofTableController.moreOptionsWarning
                    ? t("lblSomeDefaultTableOptionsWereChanged", "Some Default Table Options Were Changed")
                    : null
                }
                placement="topLeft"
                mouseLeaveDelay={0}
              >
                <Badge status={ofTableController.moreOptionsWarning ? "warning" : null} offset={[-5, 0]}>
                  <Button data-e2e="more-table-options-btn" size={buttonSize} style={{ marginRight: "5px", width: 24 }}>
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                  </Button>
                </Badge>
              </Tooltip>
            </Dropdown>

            {ofTableController.props?.pagination && <Pagination />}

            <TableSearch ofTableController={ofTableController} />
          </>
        )}

        {menuButtons && renderCustomButtons()}
      </div>
    );
  }
);

export { RenderTableMenu };
